export default __webpack_public_path__ + "static/media/microchip.5ceb77a4.png";